import { useEffect, useMemo, useState } from "react";
import TrackerHistoryModal from "./TrackerHistoryModal/TrackerHistoryModal";
import TrackerProductsModal from "./TrackerProductsModal/TrackerProductsModal";

import "./TrackerTable.css";

const TrackerViewer = () =>{
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(null);
  const [loading, setLoading] = useState(false);
   
  const [selectedUser, setSelectedUser] = useState(null);
  const [historyUser, setHistoryUser] = useState(null);
  const [productsUser, setProductsUser] = useState(null);

    const openHistory = (user) => {
        setSelectedUser(user);
    };

    const closeHistory = () => {
        setSelectedUser(null);
    };

	function formatDate(dateValue) {
	    if (!dateValue) {
	        return "-";
	    }

	    const normalizedDate = String(dateValue).replace(" ", "T");
	    const date = new Date(normalizedDate);

	    if (Number.isNaN(date.getTime())) {
	        return dateValue;
	    }

	    return new Intl.DateTimeFormat("es-PE", {
	        dateStyle: "medium",
	        timeStyle: "medium",
	    }).format(date);
	}

  const [filters, setFilters] = useState({
    platform: "",
    device: "",
    link: "",
    createdAt: "",
    userId: "",
  });

  useEffect(() => {
    loadData(page);
  }, [page,filters]);

  async function loadData(currentPage) {
    setLoading(true);

    try {
    /*platform,
    device,
    fecha,
    link,*/
      console.log(filters.createdAt)
      //filters.createdAt
      const response = await fetch(`https://tracker.freshmart.pe/tracker/views/panel?page=${currentPage}&device=${filters.device}&platform=${filters.platform}&link=${filters.link}&fecha=${filters.createdAt}`);
      const result = await response.json();

      setRows(result.data || []);
      setPagination(result.pagination || null);
    } catch (error) {
      console.error("Error cargando tracker:", error);
    } finally {
      setLoading(false);
    }
  }

  function handleFilterChange(event) {
    const { name, value } = event.target;

    setFilters((current) => ({
      ...current,
      [name]: value,
    }));
  }

  function clearFilters() {
    setFilters({
      platform: "",
      device: "",
      link: "",
      createdAt: "",
      userId: "",
    });
  }

  const filteredRows = useMemo(() => {
    return rows
    /*rows.filter((row) => {
      const rowDate = row.created_at ? row.created_at.substring(0, 10) : "";

      return (
        (!filters.platform || row.platform === filters.platform) &&
        (!filters.device || row.device === filters.device) &&
        (!filters.link ||
          String(row.link || "")
            .toLowerCase()
            .includes(filters.link.toLowerCase())) &&
        (!filters.createdAt || rowDate === filters.createdAt) &&
        (!filters.userId || String(row.user_id || "") === filters.userId)
      );
    }
    );
    */
  //}, [rows, filters]);
    }, [rows]);

  return (
    <main className="tracker-container">
      <h1 className="tracker-title">Tracker</h1>

      <section className="tracker-filters">
        <div className="tracker-field">
          <label htmlFor="platform">Platform</label>
          <select
            id="platform"
            name="platform"
            value={filters.platform}
            onChange={handleFilterChange}
          >
            <option value="">Todos</option>
            <option value="Windows">Windows</option>
            <option value="macOS">macOS</option>
            <option value="Linux">Linux</option>
            <option value="Android">Android</option>
            <option value="iOS">iOS</option>
          </select>
        </div>

        <div className="tracker-field">
          <label htmlFor="device">Device</label>
          <select
            id="device"
            name="device"
            value={filters.device}
            onChange={handleFilterChange}
          >
            <option value="">Todos</option>
            <option value="desktop">Desktop</option>
            <option value="mobile">Mobile</option>
            <option value="tablet">Tablet</option>
          </select>
        </div>

        <div className="tracker-field">
          <label htmlFor="link">Link</label>
          <input
            id="link"
            name="link"
            type="text"
            placeholder="Buscar link, sku, nombre página"
            value={filters.link}
            onChange={handleFilterChange}
          />
        </div>

        <div className="tracker-field">
          <label htmlFor="createdAt">Fecha</label>
          <input
            id="createdAt"
            name="createdAt"
            type="date"
            value={filters.createdAt}
            onChange={handleFilterChange}
          />
        </div>

        <div className="tracker-field">
          <label htmlFor="userId">Ver</label>
        </div>

        <div className="tracker-actions">
          <button type="button" className="btn-secondary" onClick={clearFilters}>
            Limpiar
          </button>
        </div>
      </section>

      {loading ? (
        <div className="tracker-empty">Cargando...</div>
      ) : filteredRows.length === 0 ? (
        <div className="tracker-empty">No hay resultados</div>
      ) : (
        <section className="tracker-table-wrap">
          <table className="tracker-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Email</th>
                <th>Platform</th>
                <th>Device</th>
                <th>Link</th>
                <th>Fecha</th>
                <th>Ver Historial</th>
                <th>Carrito Actual</th>
              </tr>
            </thead>

            <tbody>
              {filteredRows.map((row) => (
                <tr key={row.token}>
                  <td data-label="Nombre">
                    {row.name || "--"}
                  </td>
                  <td data-label="Email">{row.email || "--"}</td>
                  <td data-label="Platform">{row.platform || ""}</td>
                  <td data-label="Device">{row.device || ""}</td>
                  <td data-label="Link" className="tracker-link">
                    {row.link || ""}
                  </td>
                  <td data-label="Fecha">
                                <time
                                    dateTime={String(
                                        row.created_at
                                    ).replace(" ", "T")}
                                >
                                    {formatDate(row.created_at)}
                                </time>

                  </td>
                  <td data-label="Historial"><button onClick={() => openHistory(row)}  className="btn-action" ><span className="fa fa-eye js-show-pass"></span></button></td>
                  <td data-label="Carrito Actual"><button onClick={() => setProductsUser(row) }

className="btn-action" ><img class="ico-carrito" src="https://freshmart.pe/newicons/car.svg?1"/></button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      )}

      <section className="tracker-pagination">
        <div className="tracker-pagination-info">
          {pagination
            ? `Página ${pagination.page} de ${pagination.totalPages} - Total: ${pagination.total}`
            : ""}
        </div>

        <div className="tracker-pagination-buttons">
          <button
            type="button"
            className="btn-secondary"
            disabled={page <= 1}
            onClick={() => setPage((current) => current - 1)}
          >
            Anterior
          </button>

          <button
            type="button"
            className="btn-primary"
            disabled={pagination && page >= pagination.totalPages}
            onClick={() => setPage((current) => current + 1)}
          >
            Siguiente
          </button>
        </div>
      </section>

            <TrackerHistoryModal
                open={Boolean(selectedUser)}
                token={selectedUser?.token}
                userName={
                    selectedUser
                        ? `${selectedUser.name ?? ""} ${
                              selectedUser.lastname ?? ""
                          }`.trim()
                        : ""
                }
                onClose={closeHistory}
            />

            <TrackerProductsModal
                open={Boolean(productsUser)}
                token={productsUser?.token}
                userName={
                    productsUser
                        ? `${productsUser.name ?? ""} ${
                              productsUser.lastname ?? ""
                          }`.trim()
                        : ""
                }
                onClose={() => setProductsUser(null)}
            />


    </main>
  );
}
export default TrackerViewer;